import { Get, Set } from "../../../../Request";
export const GetData = async (data, isApp) => {
  return await Get({
    url: isApp ? "/data/app_landing" : "/data/landing",
    data: isApp && data
    // page: page,
  }).then(data => {
    return data;
  });
};

export const getProvinces = async () => {
  return await Get({
    url: "/province/show",

    toast: true,
  }).then(data => {
    return data;
  });
};

export const getCity = async id => {
  return await Get({
    url: "/city/show",
    data: { province_id: id },
    toast: true,
  }).then(data => {
    return data;
  });
};
export const getRegion = async id => {
  return await Get({
    url: "/region/show",
    data: { city_id: id },
    toast: true,
  }).then(data => {
    return data;
  });
};

export const getCategory = async () => {
  return await Get({
    url: "/category/show_all",
    data: { limit: 15 },
  }).then(data => {
    return data.data;
  });
};
